import GetShopOrderPagedListRequestModelBase from '../_generated/modelBases/get-shop-order-paged-list-request-model-base';

export default class GetShopOrderPagedListRequestModel extends GetShopOrderPagedListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
